import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fcsc-global-data',
  templateUrl: './fcsc-global-data.component.html',
  styleUrls: ['./fcsc-global-data.component.scss']
})
export class FcscGlobalDataComponent {

  constructor() { }

}
